import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { StartCourseCyLRequest } from '../models/start-course-cyl-request.model';

@Injectable({
  providedIn: 'root'
})
export class ImportService {

  private apiUrl = `${environment.sgcApi}`;
  private importsRoute = 'massiveActions/';

  constructor(
    private httpClient: HttpClient
  ) {}

  startCourseCyL(startCourseCyL: StartCourseCyLRequest, exerciseId: number, user: string) {
    let endpoint = `${this.apiUrl}${this.importsRoute}startCourse/exerciseId/${exerciseId}/user/${user}/cyl`;
    return this.httpClient.put(endpoint, JSON.stringify(startCourseCyL));
  }
}
